module.exports = new __parcel__URL__("safepal.3b3954cf.svg").toString();